
import eventTrackers, { ValidEventActions } from '../../../analytics/eventTrackers';
import { IStateTreeNode, flow } from 'mobx-state-tree';

export function withEventTrackingAsync(self: IStateTreeNode, eventActionName: ValidEventActions, action: Function) {
  return flow(function* (...args: any[]) {
    try {
      const result = action.apply(self, args);
      if (result && typeof result[Symbol.iterator] === 'function') {
        yield* result;  // It's an iterable, so yield* can be used
      } else if (result && typeof result.then === 'function') {
        yield result;  // It's a promise, yield to wait for the promise to resolve
      }
      const trackEvent = eventTrackers[eventActionName];
      if (trackEvent) {
        trackEvent();
      }

    } catch (err) {
      console.error('Error in wrapped generator action:', err);
    }
  });
}
